function remove_update_cart(variant_id,points,point_type,quantity){
var orgvarexists=document.getElementById('orig_var'); 
     
          if (orgvarexists){
          var orig_var=document.getElementById('orig_var').innerHTML;
                       if (orig_var.length>0){

jQuery.post('/cart/change.js', {
  id: orig_var,
  quantity: 0
})
.done(function(cart) {
add_gc_to_cart(variant_id,points,point_type,quantity); 
})
.fail(function(xhr, status, error) {
 remove_error();
});
              
              
            }else{
            remove_error();
            }
          }else{
 remove_error();
            
          }

 
}

function remove_error(){

alert('There was an error with your submission. Please try again.'); 
  
}


function add_gc_to_cart(variant_id,points,point_type,quantity=1){

    var co='';
if (document.getElementById("sponsor_link")){
var sponsor_link=document.getElementById("sponsor_link").innerHTML;
 
  if (sponsor_link==1){
    if (document.getElementById("sponsor_col_title")){
var sponsor_col_title=document.getElementById("sponsor_col_title").innerHTML;
if (sponsor_col_title.length>0){
var co=sponsor_col_title;
  
}
      
    }
  }else{

  if (document.getElementById("top_product")){
var top_product=document.getElementById("top_product").innerHTML;
if (top_product.length>0){
var co=top_product;
  
}
      
    }
    
    
  }

  
}else{
  var co='';
}
// var points=points*quantity;     
    if (points>0){
    document.getElementById("ynbtns").style.display="none" ;   
   document.getElementById("mod_spinner").style.display="block" ;  
    }else{
     document.getElementById("atc").style.display="none" ;   
   document.getElementById("spinner").style.display="block" ;    
    }
  
   // var quantity=1;
    //alert(variant_id+"-"+points+"-"+point_type);
  
    if (points>0){
      if (point_type==2){
      var point_message=points+" Partner Loyalty Points";
      }else if (point_type==4){
       var point_message=points+" Local Loyalty Points"; 
      }else{
         var point_message=points+" Discovery Points";
      }
    }else{
      var point_message="";
      
    }



    
       jQuery.post('/cart/add.js', {
 
  quantity:quantity,
 id:variant_id,
      properties: {
       // 'Points Required': point_message,
        'Sponsored by':co
              
    },
      
   success: addToCartSuccess(variant_id,quantity)
       
  
});
  
    
  }
  
  
  
   
  function addToCartSuccess(variant_id,quantity){
 
    var cust_id= document.getElementById('customer_number').innerHTML;
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", ""); 
    
    var product_id= document.getElementById('gc_product_id').innerHTML;
    var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
    var product_id =product_id.replace("</a>", ""); 

 var sale_type= document.getElementById('sale_type').innerHTML;
  
  //alert(variant_id+'-'+cust_id+'-'+product_id+'-'+sale_type)   
    
     $.post("https://buylocalus.com/apps/blusapp/add_cart_points.php",{cust_id:cust_id,product_id:product_id,variant_id:variant_id,sale_type:sale_type,quantity:quantity},function(data){
  // alert(data)      
                              
  setInterval(check_cart, 1000,product_id);
  
       
     });
                              
  } 


function check_cart(product_id){
                                
jQuery.getJSON('/cart.js', function(cart) {
   var cart_count=cart.items.length;
  
 
   if (cart_count>0){
     
    for (var i = 0, len = cart_count; i < len; i++) {
    //alert(cart.items[i]['product_id']);
      if (cart.items[i]['product_id']==product_id){
        window.location.href = '/cart';
      }
    }
   }
  
  
});
  
}